import React, {
  createContext,
  useContext,
  useState,
  useMemo,
} from 'react';
import { ThemeProvider as MUIThemeProvider } from '@mui/material/styles';
import getTheme from '../theme';
import { USER_LOCAL_STORAGE } from '../constants/user';

const ThemeContext = createContext();

const DEFAULT_THEME = 'light';

export function ThemeProvider({ children }) {
  const [themeMode, setThemeMode] = useState(() => {
    try {
      return localStorage.getItem(USER_LOCAL_STORAGE.THEME) || DEFAULT_THEME;
    } catch (error) {
      console.error('Failed to get theme from localStorage:', error);
      return DEFAULT_THEME;
    }
  });

  const theme = useMemo(() => getTheme({
    themeMode,
  }), [themeMode]);

  const toggleTheme = () => {
    setThemeMode((prevMode) => {
      const value = prevMode === DEFAULT_THEME ? 'dark' : DEFAULT_THEME;
      try {
        localStorage.setItem(USER_LOCAL_STORAGE.THEME, value);
      } catch (error) {
        console.error('Failed to save theme to localStorage:', error);
      }
      return value;
    });
  };

  const contextValue = useMemo(() => ({
    theme,
    themeMode,
    toggleTheme,
  }), [theme, themeMode]);

  return (
    <ThemeContext.Provider value={contextValue}>
      <MUIThemeProvider theme={theme}>
        {children}
      </MUIThemeProvider>
    </ThemeContext.Provider>
  );
}

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within ThemeProvider');
  }
  return context;
};
